import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.100098 15.1501V0.850098L11.1501 8.0001L0.100098 15.1501Z",
		fill: "#E3E3E3"
	})
});
export default SvgPlay;
